import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Segment,
  Text,
  Link,
} from './styles';

const SubmitNewStudy = (props) => {
  const { history, token } = props;
  const handleClick = () => history.push(`/recruit-participants?token=${token}`);

  return (
    <Container>
      <Segment>
        <Text>You&apos;ve already submitted this study</Text>
        <Link
          onClick={handleClick}
        >
          Submit another study
        </Link>
      </Segment>
    </Container>
  );
};

SubmitNewStudy.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  token: PropTypes.string.isRequired,
};

export default SubmitNewStudy;
